import { Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { _className, AwaitModules, ComponentSync, LL_H_C, TS_Loader, TS_PropRenderer } from '@nu-art/thunderstorm-frontend/index';
import { __stringify, _keys, asArray, MUSTNeverHappenException } from '@nu-art/ts-common';
import { AccessLevel, ModuleFE_PermissionsAssert } from '@nu-art/permissions-frontend/modules/ModuleFE_PermissionsAssert';
import { SessionKeyFE_OrganizationPermission } from '../consts.js';
import { ModuleFE_Organization } from '@app/org-frontend';
import { DropDown_OrganizationPermissions } from '../_entity/organization-permission/ui/ui-components.js';
import { ModuleFE_OrganizationPermission } from '../_entity/organization-permission/ModuleFE_OrganizationPermission.js';
export class Component_OrganizationPermissionEditor extends ComponentSync {
    componentDidMount() {
        if (!this.props.module)
            return;
        // @ts-ignore
        this[this.props.module.defaultDispatcher.method] = (...params) => {
            if (params[0] === 'delete' || params[0] === 'delete-multi') {
                return;
            }
            const item = asArray(params[1])[0];
            if (item?._id !== this.props.item._id)
                return;
            this.setState({ currentOrganizationId: this.resolveCurrentOrgPermissionId(item) });
        };
    }
    componentWillUnmount() {
        if (!this.props.module)
            return;
        // @ts-ignore
        delete this[this.props.module.defaultDispatcher.method];
    }
    deriveStateFromProps(nextProps, state) {
        state.currentOrganizationId = this.resolveCurrentOrgPermissionId(nextProps.item);
        state.editMode = nextProps.disabled
            ? false
            : ModuleFE_PermissionsAssert.getAccessLevel(ModuleFE_OrganizationPermission.permissions.collection.write) === AccessLevel.HasAccess;
        return state;
    }
    resolveCurrentOrgPermissionId(item) {
        const orgIdToAccessLevels = SessionKeyFE_OrganizationPermission.get().orgIdToAccessLevels;
        const readAccessLevel = item.meta?.read[0];
        if (!readAccessLevel)
            return undefined;
        // Find the relevant org id from the session data information
        const relevantOrgId = _keys(orgIdToAccessLevels).find(orgId => {
            if (orgIdToAccessLevels[orgId].includes(readAccessLevel))
                return true;
        });
        if (!relevantOrgId)
            // throw new BadImplementationException('cannot resolve org id');
            this.logWarning(`Could not resolve org id for object: [${this.props.module.dbDef.dbKey}] ${__stringify(item.meta)}`); // New pathway?
        return relevantOrgId;
    }
    // render tag
    renderOrgName = () => {
        const currentOrganization = ModuleFE_Organization.cache.unique(this.state.currentOrganizationId);
        if (!currentOrganization)
            throw new MUSTNeverHappenException(`cannot find organization with id ${this.state.currentOrganizationId}`);
        const className = _className('org-permission-editor__org-name', this.props.orgNameClassName);
        return _jsx("div", { className: className, children: currentOrganization.alias ?? currentOrganization.name });
    };
    renderOrgDropdown = () => {
        return _jsxs(LL_H_C, { className: 'org-permission-editor__dropdown-container', children: [_jsx(DropDown_OrganizationPermissions.selectable, { className: this.props.dropdownClassName, selected: ModuleFE_OrganizationPermission.cache.unique(this.state.currentOrganizationId), 
                    // race condition with sync and generic dropdown, I provide the dropdown with the items when sync of org permission collection is done
                    // generic dropdown is a const and being "prepared" before sync is complete on org permission module, so it has no data
                    //TODO: add modules to await in generic dropdown prepare function
                    itemResolver: () => ModuleFE_OrganizationPermission.cache.allMutable(), onSelected: orgPermission => {
                        if (orgPermission._id === this.state.currentOrganizationId)
                            return;
                        this.setState({ updatingObject: true }, async () => {
                            try {
                                if (!await this.props.preSelectCallback?.())
                                    return;
                                const latestItem = this.props.module.cache.unique(this.props.item._id);
                                if (!latestItem)
                                    throw new MUSTNeverHappenException('cannot update ');
                                await ModuleFE_OrganizationPermission._v1.changeOrganizationOwnership({
                                    instance: latestItem,
                                    targetOrganizationId: orgPermission._id,
                                    collectionName: this.props.module.dbDef.dbKey
                                }).executeSync();
                            }
                            finally {
                                this.setState({ updatingObject: false });
                            }
                        });
                    } }), this.state.updatingObject && _jsx(TS_Loader, { style: { height: '30px', width: '30px' } })] });
    };
    renderBody = () => {
        if (!this.state.currentOrganizationId) {
            return _jsx(_Fragment, {});
        }
        if (this.props.indicatorMode)
            return this.renderOrgName();
        const Renderer = TS_PropRenderer[this.props.direction];
        return _jsx(Renderer, { label: 'Organization', className: 'org-permission-editor', children: this.state.editMode ? this.renderOrgDropdown() : this.renderOrgName() });
    };
    render() {
        return _jsx(AwaitModules, { customLoader: _jsx(TS_Loader, { style: { height: '30px', width: '30px' } }), modules: [ModuleFE_Organization, ModuleFE_OrganizationPermission], children: _jsx(this.renderBody, {}) });
    }
}
//# sourceMappingURL=Component_OrganizationPermissionEditor.js.map